import { Injectable } from '@angular/core';

import { ContactService } from '../services/contact.service';

@Injectable()
export class ContactsResolver  {
  constructor(private contactService: ContactService) { }

  resolve() {
    return this.contactService.getContacts();
  }
}
